import type { Test } from '@/data'
import ChanceToWin from './chanceToWin'
import { ConfidenceInterval } from './ConfidenceInterval'

import styles from '../index.module.css'
import componentStyles from './components.module.css'

export default function Modal({
  modalOpen,
  modalData,
  formatter,
  colorRenderer,
  closeModal,
}: {
  modalOpen: boolean
  modalData: Test | undefined
  formatter: (val: string | number | null | undefined) => string
  colorRenderer: (val: string | number | undefined) => string
  closeModal: () => void
}) {
  if (!modalData) return <></>
  const combinedFlows = [
    { flow: modalData.base_flow, isControl: true } as unknown as {
      flow: Test
      isControl: boolean
    },
    ...modalData.flows,
  ]
  return (
    <div
      className={`${styles.modal} ${modalOpen ? styles['modal--open'] : ''}`}
    >
      {modalData && (
        <>
          <div className={styles['modal-content']}>
            <div className={componentStyles['modal-header']}>
              <div>{modalData.name}</div>
              <div onClick={closeModal} style={{ cursor: 'pointer' }}>
                X
              </div>
            </div>
            <div className={styles['modal-table']}>
              <table className={componentStyles['modal-table']}>
                <thead>
                  <tr>
                    <th>Variant</th>
                    <th>Traffic %</th>
                    <th>Visitors</th>
                    <th>CVR %</th>
                    <th>Growth</th>
                    <th>Leads</th>
                    <th>LTC %</th>
                    <th>LTD Δ</th>
                    <th>Enrollments</th>
                    <th>Enrollment %</th>
                    <th>Enrollment Δ</th>
                    <th>Chance to Win</th>
                    <th>Confidence Interval</th>
                  </tr>
                </thead>
                <tbody>
                  {combinedFlows.map((mdFlow, idx) => {
                    let consumedTraffic = 0
                    if (Object.keys(mdFlow).includes('isControl')) {
                      consumedTraffic = combinedFlows
                        .map((vnt) => {
                          //@ts-expect-error - needs some cast magic
                          return vnt.traffic_percentage
                        })
                        .filter((traffic_percentage) => {
                          return typeof traffic_percentage !== 'undefined'
                        })
                        .reduce(
                          (accumulator, currentValue) =>
                            accumulator + currentValue,
                          0,
                        )
                    }
                    return (
                      <>
                        <tr className={idx % 2 == 1 ? 'zebra' : ''}>
                          <td className={componentStyles['td-left']}>
                            {mdFlow.flow ? mdFlow.flow.name : 'Unnamed Flow'}
                          </td>
                          <td className={componentStyles['td-center']}>
                            {formatter(
                              //@ts-expect-error - needs some cast magic
                              mdFlow.traffic_percentage
                                ? //@ts-expect-error - needs some cast magic
                                  mdFlow.traffic_percentage
                                : 100 - consumedTraffic,
                            )}
                          </td>
                          <td className={componentStyles['td-center']}>
                            {mdFlow.flow?.metrics?.visitor_count}
                          </td>
                          <td className={componentStyles['td-center']}>
                            {formatter(mdFlow.flow?.metrics?.cvr)}
                          </td>
                          <td
                            className={componentStyles['td-center']}
                            style={{
                              color: colorRenderer(
                                mdFlow.flow?.metrics?.growth.toString(),
                              ),
                            }}
                          >
                            {formatter(mdFlow.flow?.metrics?.growth)}
                          </td>
                          <td className={componentStyles['td-center']}>
                            {mdFlow.flow?.metrics?.lead_count}
                          </td>
                          <td className={componentStyles['td-center']}>
                            {formatter(mdFlow.flow?.metrics?.ltc)}
                          </td>
                          <td
                            className={componentStyles['td-center']}
                            style={{
                              color: colorRenderer(
                                mdFlow.flow?.metrics?.ltc_delta,
                              ),
                            }}
                          >
                            {formatter(mdFlow.flow?.metrics?.ltc_delta)}
                          </td>
                          <td className={componentStyles['td-center']}>
                            {mdFlow.flow?.metrics?.enrollments}
                          </td>
                          <td className={componentStyles['td-center']}>
                            {formatter(mdFlow.flow?.metrics?.enrollment_rate)}
                          </td>
                          <td
                            className={componentStyles['td-center']}
                            style={{
                              color: colorRenderer(
                                mdFlow.flow?.metrics?.enrollment_delta,
                              ),
                            }}
                          >
                            {formatter(mdFlow.flow?.metrics?.enrollment_delta)}
                          </td>
                          <td className={componentStyles['td-center']}>
                            {idx === 0 && <>Control</>}

                            {idx > 0 && (
                              <ChanceToWin
                                chance={mdFlow.flow?.metrics?.chance_to_win}
                              />
                            )}
                          </td>
                          <td className={componentStyles['td-center']}>
                            {idx === 0 && <>Control</>}
                            {idx > 0 &&
                              mdFlow.flow &&
                              mdFlow.flow.metrics &&
                              mdFlow.flow.metrics.confidence_interval && (
                                <ConfidenceInterval
                                  confidenceInterval={
                                    mdFlow.flow?.metrics?.confidence_interval
                                  }
                                  growth={mdFlow.flow.metrics.growth}
                                />
                              )}
                          </td>
                        </tr>
                      </>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
